export default __webpack_public_path__ + "static/media/bottom_japan_online.172dec60.png";